import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import ImageWithRetry from "./ImageWithRetry";

/** Square Images */
const ImageWrapper = ({ src, alt = "Image", padding = 0, size = "md" }) => {
  const sizeMap = {
    sm: "h-16 w-16", // (64px)
    "80px": "h-[80px] w-[80px]", // (80px)
    md: "h-24 w-24", // (96px)
    lg: "h-32 w-32", // (128px)
    xl: "h-64 w-64", // (256px)
    "2xl": "h-96 w-96", // (384px)
    full: "h-full w-full",
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div
        data-id={`image-container`}
        className={`${sizeMap[size]} p-${padding}`}
      >
        <ImageWithRetry
          src={src}
          alt={alt}
          className="w-full h-full object-contain rounded-lg"
        />
      </div>
    </div>
  );
};

export const imageWrapperControls = {
  padding: {
    propTypes: PropTypes.number,
    controlType: "select",
    options: [2, 3, 4, 5, 6],
    description: "Padding around image",
  },
  src: {
    propTypes: PropTypes.string,
    controlType: "text",
    description: "Url to image",
  },
  alt: {
    propTypes: PropTypes.string,
    controlType: "text",
    description: "Alt text for image",
  },
  size: {
    propType: PropTypes.string,
    controlType: "select",
    options: ["sm", "md", "lg", "xl", "2xl"],
    description: "Size of the image",
  },
};

ImageWrapper.propTypes = AppUtils.getPropTypeFromControls(imageWrapperControls);

export default ImageWrapper;
